<template>
  <section class="page-wrap">
    <UiPageHero
      eyebrow="Tài khoản"
      title="Cập nhật tài khoản"
      description="Điều chỉnh thông tin, phân quyền hoặc khóa tài khoản."
    />

    <form class="panel-pad max-w-4xl" @submit.prevent="save">
      <div class="grid gap-4 md:grid-cols-2">
        <UiInput v-model="user.username" label="Tên đăng nhập" />
        <UiInput
          v-model="user.password"
          label="Mật khẩu mới"
          type="password"
          placeholder="Để trống nếu không đổi"
        />
        <UiInput v-model="user.fullname" label="Họ tên" />
        <UiInput v-model="user.phoneNumber" label="Số điện thoại" />
        <UiSelect v-model="user.permission" label="Quyền">
          <option value="user">Người dùng</option>
          <option value="admin">Quản trị viên</option>
        </UiSelect>
        <UiSelect v-model.number="user.idKhoaPhong" label="Khoa/phòng">
          <option :value="0">Chọn khoa/phòng</option>
          <option v-for="item in khoaPhong" :key="item.id" :value="item.id">
            {{ item.tenKhoaPhong }}
          </option>
        </UiSelect>
        <UiCheckbox v-model="user.active">
          Tài khoản đang hoạt động
        </UiCheckbox>
      </div>

      <div class="mt-5 flex flex-wrap gap-3">
        <UiButton type="submit" icon="save" :loading="loading" loading-text="Đang lưu...">
          Lưu thay đổi
        </UiButton>
        <UiButton variant="danger" icon="delete" @click="removeUser">
          Xóa tài khoản
        </UiButton>
        <UiButton to="/userlist" variant="secondary" icon="back">Quay lại</UiButton>
      </div>
    </form>
  </section>
</template>

<script lang="ts">
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import AuthRepository from "@/services/AuthRepository";
import QLTSRepository from "@/services/QLTSRepository";
import { UserUpdate } from "@/models/userUpdate";
import { KhoaPhong } from "@/models/khoaPhong";
import { getErrorMessage, useToast } from "@/utils/toast";

export default {
  props: { id: { type: String, required: true } },
  setup(props: any) {
    const router = useRouter();
    const loading = ref(false);
    const { showToast } = useToast();
    const khoaPhong = ref<KhoaPhong[]>([]);
    const user = ref<UserUpdate>({
      id: Number(props.id),
      username: "",
      password: "",
      fullname: "",
      permission: "user",
      idKhoaPhong: 0,
      phoneNumber: "",
      active: true,
    });

    onMounted(() => {
      QLTSRepository.getListKhoaPhong().then((res) => {
        khoaPhong.value = res.data || [];
      });
      AuthRepository.getById(Number(props.id)).then((res) => {
        user.value = { ...user.value, ...res.data, password: "" };
      });
    });

    const save = () => {
      loading.value = true;
      AuthRepository.updateUser(user.value)
        .then(() => {
          showToast("Đã cập nhật tài khoản.", "success");
        })
        .catch((err) => {
          showToast(
            getErrorMessage(err, "Không cập nhật được tài khoản."),
            "error",
          );
        })
        .finally(() => (loading.value = false));
    };

    const removeUser = () => {
      if (!window.confirm("Xóa tài khoản này?")) return;
      AuthRepository.delete(user.value.id)
        .then(() => {
          showToast("Đã xóa tài khoản.", "success");
          router.push("/userlist");
        })
        .catch((err) => {
          showToast(getErrorMessage(err, "Không xóa được tài khoản."), "error");
        });
    };

    return { user, khoaPhong, loading, save, removeUser };
  },
};
</script>

